import { Page } from '@/core/architecture'

import { ConsoleMembershipTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMembership Page
 * Implemented as a practical sample.
 */
export const ConsoleMembership: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleMembershipTemplate state={state} {...actions} />
}
